import IContractEntity from "../../interfaces/icontract_entity.type";

export default class ContractEntity {
   private readonly id: string;
   private readonly name: string | undefined;
   private readonly plan: string;
   private readonly created: string;
   private readonly expires: string;
   private readonly isTrial: boolean;
   constructor(
      contractProperties: IContractEntity
   ) {
      this.id = contractProperties.id;
      this.name = contractProperties.name;
      this.plan = contractProperties.plan;
      this.created = contractProperties.created;
      this.expires = contractProperties.expires;
      this.isTrial = contractProperties.is_trial;
   }
   getId = () => this.id;
   getName = () => this.name;
   getPlan = () => this.plan;
   getCreated = () => this.created;
   getExpires = () => this.expires;
   getIsTrial = () => this.isTrial;
   toObject = () => ({
      id: this.getId(),
      name: this.getName(),
      plan: this.getPlan(),
      created: this.getCreated(),
      expires: this.getExpires(),
      isTrial: this.getIsTrial()
   });
}

